import React from 'react';
import styled from 'styled-components';
import { theme } from '../../theme';

const SocialMediaContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;

  @media (max-width: 480px) {
    gap: 10px;
  }
`;

const SocialLinksContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;

  @media (max-width: 480px) {
    gap: 12px;
  }
`;

const SocialLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
  text-decoration: none;

  &:hover {
    transform: scale(1.1);
  }

  /* Filtre spécial pour Instagram pour enlever le fond blanc */
  &:first-child img {
    background: transparent;
    mix-blend-mode: darken;
  }

  /* Maintenir le filtre au hover pour Instagram */
  &:first-child:hover img {
    background: transparent;
    mix-blend-mode: darken;
  }

  img {
    width: 32px;
    height: 32px;
    object-fit: contain;

    @media (max-width: 480px) {
      width: 28px;
      height: 28px;
    }
  }
`;

interface SocialMediaLinksProps {
  className?: string;
  hideYouTube?: boolean;
}

const SocialMediaLinks: React.FC<SocialMediaLinksProps> = ({ className, hideYouTube = false }) => {
  // URLs des réseaux sociaux - à modifier selon vos besoins
  const socialLinks = {
    instagram: 'https://www.instagram.com/_outchou_/',
    tiktok: 'https://www.tiktok.com/@_outchou_',
    youtube: 'https://youtube.com/@outchou_dz'
  };

  return (
    <SocialMediaContainer className={className}>
      <SocialLinksContainer>
        <SocialLink 
          href={socialLinks.instagram} 
          target="_blank" 
          rel="noopener noreferrer"
          aria-label="Instagram"
        >
          <img src="/shared_assets/images/icons/instagram.jpg" alt="Instagram" />
        </SocialLink>
        <SocialLink 
          href={socialLinks.tiktok} 
          target="_blank" 
          rel="noopener noreferrer"
          aria-label="TikTok"
        >
          <img src="/shared_assets/images/icons/tik tok.png" alt="TikTok" />
        </SocialLink>
        {!hideYouTube && (
          <SocialLink 
            href={socialLinks.youtube} 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="YouTube"
          >
            <img src="/shared_assets/images/icons/youtube.png" alt="YouTube" />
          </SocialLink>
        )}
      </SocialLinksContainer>
    </SocialMediaContainer>
  );
};

export default SocialMediaLinks;
